
import { defineComponent, reactive, ref } from "vue";
import { Field, Form } from "vee-validate";
import Switch from "@/components/widgets/custom/Switch.vue";
import moment from "moment";
import ApiService from "@/core/services/ApiService";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import Loading from "vue-loading-overlay";

const programmers = [
  "BE AJI",
  "BE ZUL",
  "BE ILHAM",
  "BE YAZID",
  "FE NUR",
  "FE INDRA",
  "FE TEGUH",
  "MOBILE AAN",
  "QA RARA",
  "QA VIKA",
  "QA RANI",
];

const location_options = ["includes", "exclude", "both"];
const statuses = ["demo", "release", "maintenance", "beta"];

interface FeatureData {
  name: string;
  releaseDate: string;
  description: string;
  programmer: string;
  position: string;
  status: string;
  is_default: boolean;
}

interface ModuleDetail {
  moduleKey: string;
  moduleDescription: string;
  status: string;
  is_default: boolean;
}

export default defineComponent({
  name: "Add Feature",
  components: {
    Field,
    Form,
    Switch,
    Loading,
  },
  setup() {
    const isLoading = ref(false);
    const fullPage = ref(false);
    const isColor = "#007BFF";
    const isBackgroundColor = "#A3A3A3";
    const isOpacity = 0.5;
    const userStorage = ref(localStorage.getItem("user_account"));
    const currentUser = ref();
    const toast = useToast();
    const router = useRouter();

    if (userStorage.value) {
      currentUser.value = JSON.parse(userStorage.value);
    }
    const featureData = reactive<FeatureData>({
      name: "",
      releaseDate: "",
      description: "",
      programmer: "",
      position: "",
      status: "",
      is_default: false,
    });

    const moduleDetail = reactive<ModuleDetail[]>([
      {
        moduleKey: "",
        moduleDescription: "",
        status: "Active",
        is_default: false,
      },
    ]);

    const addModuleDetail = (index) => {
      if (
        moduleDetail[index].moduleDescription === "" ||
        moduleDetail[index].moduleKey === ""
      )
        return toast.warning("field tidak boleh kosong");
      moduleDetail.push({
        moduleKey: "",
        moduleDescription: "",
        status: "Active",
        is_default: false,
      });
    };

    const changeStatus = (index: number) => {
      moduleDetail[index].status =
        moduleDetail[index].status === "Active" ? "Inactive" : "Active";
    };

    const removeDetail = (index) => {
      moduleDetail.splice(index, 1);
    };

    const handleSubmit = () => {
      isLoading.value = true;
      const savedDetailModules = moduleDetail.map((item) => {
        return {
          module_key: item.moduleKey,
          module_description: item.moduleDescription,
          status: item.status,
          is_default: item.is_default,
        };
      });
      const data = {
        createTime: moment().toISOString(),
        creatorId: currentUser.value.userId,
        updateTime: moment().toISOString(),
        editorId: currentUser.value.userId,
        isDelete: false,
        deleteBy: null,
        deleteTime: moment().toISOString(),
        feature_name: featureData.name,
        release_date: featureData.releaseDate,
        description: featureData.description,
        programmer: featureData.programmer,
        feature_location: featureData.position,
        feature_status: featureData.status,
        detail_modules: savedDetailModules,
        is_default: featureData.is_default,
      };
      ApiService.postWithData("crmv2/main_feature/feature-master", data)
        .then((res) => {
          console.log(res);
          toast.success("Data berhasil disimpan");
          router.push("/superadmin/master-feature/data");
        })
        .catch((e) => {
          console.log(e);

          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            router.push("/sign-in");
            isLoading.value = false;
          } else {
            toast.error("Something went wrong");
            isLoading.value = false;
          }
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    return {
      isLoading,
      fullPage,
      isColor,
      isBackgroundColor,
      isOpacity,
      featureData,
      moduleDetail,
      programmers,
      location_options,
      statuses,
      addModuleDetail,
      changeStatus,
      removeDetail,
      handleSubmit,
    };
  },
});
